import styled from 'styled-components';

export const GuaranteeTypeItem = styled.label`
  cursor: pointer;

  &:hover {
    background: ${(props) => props.theme.$gray100} !important;
  }
`;

export const DropZone = styled.button`
  background-color: #eef5ff;
  border: 1px dashed ${(props) => props.theme.$primary};
  border-radius: 0.5rem;
`;

export const FileChip = styled.span`
  background-color: ${(props) => props.theme.$gray100};
  border: 1px solid ${(props) => props.theme.$gray300};
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem;
`;
